import React from 'react';
import { useParams } from 'react-router';

import { ResourceTypeDto } from '@/api/generated';
import { ItemDetailsFilesTab } from '@/components/tabs/ItemDetailsFilesTab.comp.tsx';

export const ProcessDetailsFilesTab: React.FC = () => {
  const { processId } = useParams();

  if (!processId) {
    return null;
  }

  return <ItemDetailsFilesTab resourceId={processId} resourceType={ResourceTypeDto.Process} />;
};
